import { ProductCard as DesktopProductCard } from '@/features/plp/presentation/components/ProductCard_desktop_v3_4';
import { useMemo } from 'react';
import type { SimilarDesignItem } from '../../domain/models/SimilarDesignItem';
import { ProductCard } from '@/features/plp/presentation/components/ProductCard';
import type { ListingDesignItem } from '@/features/plp/domain/models/ProductListing';

import { toPriceNumber, formatDisplayPrice } from '@/shared/utils/priceFormatter';

interface SimilarDesignCardProps {
  item: SimilarDesignItem;
  openInNewTab?: boolean;
  compactPinkWishlist?: boolean;
  desktopInline?: boolean;
  onDesignClick?: (designId: number, designName: string) => void;
}

function mapSimilarDesignItemToListingDesignItem(item: SimilarDesignItem): ListingDesignItem {
  const parsedPrice = item.price != null ? toPriceNumber(item.price) : null;
  const parsedDiscountedPrice = item.discountedPrice != null ? toPriceNumber(item.discountedPrice) : null;

  return {
    designId: item.designId,
    designName: item.designName,
    imageUrl: item.imageUrl,
    customizationId: item.customizationId,
    videoUrl: item.videoUrl,
    videoPosterUrl: item.videoPosterUrl,
    productPageUrl: item.productPageUrl ?? '',
    price: parsedPrice !== null ? formatDisplayPrice(parsedPrice) : '₹ 0',
    discountedPrice: parsedDiscountedPrice !== null ? formatDisplayPrice(parsedDiscountedPrice) : undefined,
  };
}

export function SimilarDesignCard({ item, onDesignClick, openInNewTab, compactPinkWishlist, desktopInline }: SimilarDesignCardProps) {
  const mappedProduct = useMemo(() => mapSimilarDesignItemToListingDesignItem(item), [item]);

  const handleProductClick = () => {
    if (onDesignClick) {
      onDesignClick(item.designId, item.designName);
    }
  };

  if (desktopInline) {
    return <DesktopProductCard product={mappedProduct} openInNewTab={openInNewTab}
      onProductClick={handleProductClick} hideViewDetailsButton showUnavailableVideoCallButton
      className="h-auto rounded-[5px] border border-gray-200 bg-white" />;
  }

  return (
    <ProductCard
      compactPinkWishlist={compactPinkWishlist}
      openInNewTab={openInNewTab}
      product={mappedProduct}
      className="rounded-[5px] border border-gray-200 bg-white"
      onProductClick={handleProductClick}
      hideVideoCallButton
      hideViewDetailsButton
    />
  );
}
